import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import goTo from "../../../../controllers/goTo";
import CustomButton from "../../../helperComponents/CustomButton";
import MiniProfileCard from "../MiniProfileCard";
import MaterialInput from "../../../helperComponents/MaterialInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import CustomCheckbox from "../../../helperComponents/CustomCheckbox";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import getUrlQuery from "../../../../controllers/getUrlQuery";
import ImagePicker from "../../../editors/ImagePicker";
import SiteDropDownInput from "./SiteDropDownInput";
import RoleDropDownInput from "./RoleDropDownInput";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";
import contractTypesForSite from "../../../../data/employee/contractTypesForSite";
import CustomLabel from "../../../customUiForCs/CustomLabel";
import employeeShiftTypes from "../../../../data/employee/employeeShiftTypes";
import employeeTypes from "../../../../data/employee/employeeTypes";
import { useTranslation } from "react-i18next";
import marriageStatusTypes from "../../../../data/employee/marriageStatusTypes";
import Context from "../../../../Context";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import dayOfRestTypes from "../../../../data/employee/dayOfRestTypes";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* margin-top: 100px; */
  align-items: center;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 50vw;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 50px;
  width: 800px;
  border-radius: 15px;
  background-color: var(--surface3);
  border: 1px solid var(--borderDim);

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const ColumnItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 50px;
  width: 100%;
  border-radius: 15px;
  background-color: var(--surface3);
  border: 1px solid var(--borderDim);

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 15px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Buttons = styled.div`
  width: 38vw;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

let dropDownStyle = { flex: 1 };

const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

const SubList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TwoColumnRow = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;

const ColumnInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const RowSection = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  width: 800px;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const PillButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--border);
  background: var(--gradientSurface);
  color: var(--element);
  padding: 10px 14px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: var(--lightShadow);

  &:hover {
    background: var(--accent);
    color: var(--mainBackground);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

const ModalCard = styled.div`
  background: var(--surfaceSolid);
  border: 1px solid var(--borderDim);
  border-radius: 16px;
  padding: 24px;
  width: min(520px, 100%);
  box-shadow: 0 20px 80px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ModalTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--element);
  font-weight: 700;
  font-size: 18px;

  span {
    color: var(--elementDim);
    font-weight: 500;
    font-size: 14px;
  }
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const ModalRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ModalSelect = styled.select`
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
  color: var(--element);
  font-weight: 600;
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 12px;
  color: var(--element);
  font-weight: 600;
`;

export default function AddOrEditEmployee({}) {
  const { t } = useTranslation();
  const { loggedInUser, employeeFunctions } = useContext(Context);
  const [itemID, setItemID] = useState(null);
  const [item, setItem] = useState({ registrationNumber: "", isActive: true });
  //registrationNumber should not be null
  //otherwise label and text will overlap
  //when the auto generated number is inserted

  const [loading, setLoading] = useState(false);
  const [purpose, setPurpose] = useState("ADD");
  const [customFields, setCustomFields] = useState([]);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [activeModal, setActiveModal] = useState(null); // 'add' | 'delete' | null
  const [newFieldName, setNewFieldName] = useState("");
  const [newFieldType, setNewFieldType] = useState("text");
  const [newFieldOptions, setNewFieldOptions] = useState("");

  const canManageCustomFields =
    loggedInUser?.accountType?.toUpperCase() === "DEVELOPER";

  const shiftOptions = (() => {
    let options = [...employeeShiftTypes];
    if (item?.shift && !options.some((option) => option.value === item.shift)) {
      options.push({ value: item.shift, label: `Legacy: ${item.shift}` });
    }
    return options;
  })();

  useEffect(() => {
    try {
      let cached = localStorage.getItem("cs-custom-fields-employee");
      if (cached) {
        let parsed = JSON.parse(cached);
        if (parsed.definitions) setCustomFields(parsed.definitions);
        if (parsed.values) setCustomFieldValues(parsed.values);
      }
    } catch (e) {
      console.log("Unable to read cached custom fields", e);
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(
        "cs-custom-fields-employee",
        JSON.stringify({
          definitions: customFields,
          values: customFieldValues,
        })
      );
    } catch (e) {
      console.log("Unable to persist custom fields", e);
    }
  }, [customFields, customFieldValues]);

  console.log("purpose", purpose, getUrlQuery("itemID"));
  useEffect(() => {
    let newItemID = getUrlQuery("itemID");
    setItemID(newItemID);

    if (newItemID) {
      setPurpose("UPDATE");
    } else {
      getNewRegNumber();
    }
  }, []);

  useEffect(() => {
    if (purpose == "UPDATE") {
      setLoading(true);
      if (itemID) {
        loadItemToBeEdited();
      }
    }
  }, [itemID]);

  const fieldTypeOptions = [
    { value: "text", label: "Texte" },
    { value: "number", label: "Nombre" },
    { value: "date", label: "Date" },
    { value: "textarea", label: "Texte long" },
    { value: "select", label: "Liste déroulante" },
    { value: "radio", label: "Boutons radio" },
  ];

  function upsertCustomField() {
    if (!newFieldName.trim()) return window.popupAlert("Nom du champ requis");

    let cleanedName = newFieldName.trim();
    let options = newFieldOptions
      .split(",")
      .map((opt) => opt.trim())
      .filter(Boolean);

    if (
      (newFieldType === "select" || newFieldType === "radio") &&
      options.length === 0
    ) {
      return window.popupAlert("Ajoutez au moins une option");
    }

    setCustomFields((prev) => {
      const existingIndex = prev.findIndex(
        (field) => field.name.toLowerCase() === cleanedName.toLowerCase()
      );

      let next = [...prev];
      let newField = {
        name: cleanedName,
        type: newFieldType,
        options,
      };

      if (existingIndex !== -1) {
        next[existingIndex] = newField;
      } else {
        next.push(newField);
      }
      return next;
    });

    setActiveModal(null);
    setNewFieldName("");
    setNewFieldOptions("");
    setNewFieldType("text");
  }

  function removeCustomField(name) {
    setCustomFields((prev) => prev.filter((field) => field.name !== name));
    setCustomFieldValues((prev) => {
      let copy = { ...prev };
      delete copy[name];
      return copy;
    });
  }

  function handleCustomFieldChange(fieldName) {
    return (e) => {
      let value = e?.target ? e.target.value : e;
      setCustomFieldValues((prev) => ({ ...prev, [fieldName]: value }));
    };
  }

  function renderCustomFields() {
    if (!customFields.length) return null;

    return (
      <InputItems>
        <SubSection>
          <CustomLabel>Champs personnalisés</CustomLabel>
          <SubList>
            {customFields.map((field) => (
              <ColumnInputs key={field.name}>
                {renderCustomFieldInput(field)}
              </ColumnInputs>
            ))}
          </SubList>
        </SubSection>
      </InputItems>
    );
  }

  function renderCustomFieldInput(field) {
    if (field.type === "select" || field.type === "radio") {
      let options = (field.options || []).map((opt) => ({
        value: opt,
        label: opt,
      }));

      return (
        <DropDownInput
          style={{ minWidth: "240px" }}
          options={options}
          label={field.name}
          value={customFieldValues[field.name]}
          onChange={handleCustomFieldChange(field.name)}
        />
      );
    }

    if (field.type === "textarea") {
      return (
        <MaterialInput
          multiline
          rows={3}
          label={field.name}
          value={customFieldValues[field.name] || ""}
          onChange={handleCustomFieldChange(field.name)}
        />
      );
    }

    let inputType = "text";
    if (field.type === "number") inputType = "number";
    if (field.type === "date") inputType = "date";

    return (
      <MaterialInput
        label={field.name}
        type={inputType}
        value={customFieldValues[field.name] || ""}
        onChange={handleCustomFieldChange(field.name)}
      />
    );
  }

  function renderCustomFieldModals() {
    if (!activeModal) return null;

    if (activeModal === "add")
      return (
        <ModalOverlay>
          <ModalCard>
            <ModalTitle>
              Ajouter / modifier un champ
              <span>Configurez le label et le type d’entrée.</span>
            </ModalTitle>

            <ModalRow>
              <MaterialInput
                label={"Nom du champ"}
                value={newFieldName}
                onChange={(e) => setNewFieldName(e.target.value)}
              />
            </ModalRow>

            <ModalRow>
              <ModalSelect
                value={newFieldType}
                onChange={(e) => setNewFieldType(e.target.value)}
              >
                {fieldTypeOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </ModalSelect>
            </ModalRow>

            {(newFieldType === "select" || newFieldType === "radio") && (
              <ModalRow>
                <MaterialInput
                  label={"Options (séparées par des virgules)"}
                  value={newFieldOptions}
                  onChange={(e) => setNewFieldOptions(e.target.value)}
                />
              </ModalRow>
            )}

            <ModalActions>
              <CustomButton surfaceColor="var(--surface2)" onClick={() => setActiveModal(null)}>
                Annuler
              </CustomButton>
              <CustomButton onClick={upsertCustomField}>Enregistrer</CustomButton>
            </ModalActions>
          </ModalCard>
        </ModalOverlay>
      );

    if (activeModal === "delete")
      return (
        <ModalOverlay>
          <ModalCard>
            <ModalTitle>
              Supprimer un champ
              <span>Retirez les champs personnalisés devenus inutiles.</span>
            </ModalTitle>

            <Chips>
              {customFields.length === 0 ? (
                <span style={{ color: "var(--elementDim)" }}>
                  Aucun champ personnalisé pour le moment.
                </span>
              ) : (
                customFields.map((field) => (
                  <Chip key={field.name}>
                    {field.name}
                    <PillButton
                      style={{ padding: "6px 10px" }}
                      onClick={() => removeCustomField(field.name)}
                    >
                      <FiTrash2 />
                    </PillButton>
                  </Chip>
                ))
              )}
            </Chips>

            <ModalActions>
              <CustomButton onClick={() => setActiveModal(null)}>Fermer</CustomButton>
            </ModalActions>
          </ModalCard>
        </ModalOverlay>
      );
  }

  function getHeaderActions() {
    if (!canManageCustomFields) return null;

    return (
      <HeaderActions>
        <PillButton onClick={() => setActiveModal("add")}>
          <FiPlus />
          Ajouter / modifier un champ
        </PillButton>
        <PillButton onClick={() => setActiveModal("delete")}>
          <FiTrash2 />
          Supprimer un champ
        </PillButton>
      </HeaderActions>
    );
  }

  let titleLine1 = "D'un Personnel";
  let titleLine2 = "Ajout";

  if (purpose == "UPDATE") {
    titleLine1 = "Modifier";
    titleLine2 = "Le profil de la personne";
  }

  let coreContent = <LoadingSection />;

  if (!loading) {
    coreContent = (
      <Container>
        {/* {getItemBeingEditedCard()} */}
        <Inputs>
          <TopSection>
            <UploadSection>
              <ImagePicker
                forPerson={true}
                value={item.profileImage}
                onChange={updateField("profileImage", true)}
              ></ImagePicker>
            </UploadSection>

            <MaterialInput
              permissionName="registrationNumberPermissions"
              label={"Matricule"}
              value={item.registrationNumber}
              onChange={() => {}}
              disabled={true}
            />
          </TopSection>

          <InputItems>
            <SubSection>
              <CustomLabel>Identité</CustomLabel>
              <SubList>
                <TwoColumnRow>
                  <MaterialInput
                    label={"Nom"}
                    value={item.lastName}
                    onChange={updateField("lastName")}
                    permissionName="namePermissions"
                  />

                  <MaterialInput
                    label={"Prenom"}
                    value={item.firstName}
                    onChange={updateField("firstName")}
                    permissionName="namePermissions"
                  />
                  {/* <MaterialInput
                      label={"Surnom"}
                      value={item.nickname}
                      onChange={updateField("nickname")}
                      permissionName="name"
                    /> */}
                </TwoColumnRow>

                <TwoColumnRow>
                  <MaterialInput
                    permissionName="dateOfBirthPermissions"
                    type="date"
                    label={"Date de naissance"}
                    value={item.dateOfBirth}
                    onChange={updateField("dateOfBirth")}
                  />

                  <DropDownInput
                    permissionName="genderPermissions"
                    style={dropDownStyle}
                    disableSearch={true}
                    label="Genre"
                    value={item.gender}
                    options={[
                      { value: "MALE", label: "Homme" },
                      { value: "FEMALE", label: "Femme" },
                    ]}
                    onChange={updateField("gender", true)}
                  />
                </TwoColumnRow>

                <TwoColumnRow>
                  <MaterialInput
                    permissionName="phoneNumberPermissions"
                    label={"Numéro de téléphone"}
                    value={item.phoneNumber}
                    onChange={updateField("phoneNumber")}
                  />

                  <MaterialInput
                    permissionName="cnpsNumberPermissions"
                    label={"N° CNPS"}
                    value={item.cnpsNumber}
                    onChange={updateField("cnpsNumber")}
                  />
                </TwoColumnRow>
              </SubList>
            </SubSection>
          </InputItems>
          <InputItems>
            <SubSection>
              <CustomLabel>Informations Professionnelles</CustomLabel>
              <SubList>
                <TwoColumnRow>
                  <DropDownInput
                    permissionName="employeeResponsibilityPermissions"
                    style={dropDownStyle}
                    label="Fonction"
                    options={employeeFunctions || contractTypesForSite}
                    value={item.employeeResponsibility}
                    onChange={updateField("employeeResponsibility", true)}
                  />

                  <DropDownInput
                    permissionName="contractTypePermissions"
                    style={dropDownStyle}
                    disableSearch={true}
                    label="Type de contrat"
                    value={item.contractType}
                    placeholder="Sélectionner"
                    options={[
                      { value: "CDD", label: "CDD" },
                      { value: "CDI", label: "CDI" },
                      { value: "INTERNSHIP", label: "Stage" },
                      { value: "TRIAL_CONTRACT", label: "Contrat d'essai" },
                      { value: "NONE", label: "Aucun" },
                    ]}
                    onChange={updateField("contractType", true)}
                  />
                </TwoColumnRow>

                <TwoColumnRow>
                  <MaterialInput
                    permissionName="hiringDatePermissions"
                    style={dropDownStyle}
                    type="date"
                    label={"Date d'embauche"}
                    value={item.hiringDate}
                    onChange={updateField("hiringDate")}
                  />

                  <MaterialInput
                    permissionName="contractEndDatePermissions"
                    style={dropDownStyle}
                    type="date"
                    label={"Date de fin de contrat"}
                    value={item.contractEndDate}
                    onChange={updateField("contractEndDate")}
                  />
                </TwoColumnRow>

                <TwoColumnRow>
                  <MaterialInput
                    permissionName="baseSalaryPermissions"
                    label={"Salaire de base"}
                    value={item.baseSalary}
                    onChange={updateField("baseSalary")}
                  />

                  <MaterialInput
                    permissionName="primePermissions"
                    label={"Prime"}
                    value={item.prime}
                    onChange={updateField("prime")}
                  />
                </TwoColumnRow>

                <TwoColumnRow>
                  <DropDownInput
                    permissionName="dayOfRestPermissions"
                    style={dropDownStyle}
                    disableSearch={true}
                    label="Jour de repos"
                    value={item.dayOfRest}
                    options={dayOfRestTypes}
                    onChange={updateField("dayOfRest", true)}
                  />

                  <DropDownInput
                    permissionName="shiftPermissions"
                    label={"Shift"}
                    options={shiftOptions}
                    value={item.shift}
                    onChange={updateField("shift", true)}
                  />
                </TwoColumnRow>

                <TwoColumnRow>
                  <SiteDropDownInput
                    permissionName="siteIdPermissions"
                    style={dropDownStyle}
                    label={"Site"}
                    value={item.siteID}
                    onChange={updateField("siteID", true)}
                  />

                  <DropDownInput
                    permissionName="paymentTypePermissions"
                    style={dropDownStyle}
                    label={"Type de paiement"}
                    options={[
                      { value: "DIGITAL_PAYMENT", label: "JULAYA" },
                      { value: "BANK_TRANSFER", label: "VIREMENT" },
                      { value: "CASH", label: "ESPECE" },
                    ]}
                    value={item.paymentType}
                    onChange={updateField("paymentType", true)}
                  />
                </TwoColumnRow>

                <TwoColumnRow>
                  <MaterialInput
                    permissionName="nationalityPermissions"
                    label={"Nationalité"}
                    value={item.nationality}
                    onChange={updateField("nationality")}
                  />

                  <MaterialInput
                    permissionName="numberOfChildrenPermissions"
                    label={"Nombre d'enfants"}
                    type={"number"}
                    value={item.numberOfChildren}
                    onChange={updateField("numberOfChildren")}
                  />

                  <DropDownInput
                    permissionName="marriageStatusPermissions"
                    style={dropDownStyle}
                    label={"Statut matrimonial"}
                    options={marriageStatusTypes}
                    value={item.marriageStatus}
                    onChange={updateField("marriageStatus", true)}
                  />
                </TwoColumnRow>
              </SubList>
            </SubSection>
          </InputItems>

          {/* <InputItems>
              <SubSection>
                <CustomLabel>Rémunération et Avantages </CustomLabel>
                <SubList>
                  <Row>
                
                  </Row>
                </SubList>
              </SubSection>
            </InputItems> */}

          <RowSection>
            <ColumnItems>
              <SubSection>
                <CustomLabel>Statut</CustomLabel>
                <SubList>
                  <MaterialInput
                    label={"Email"}
                    value={item.email}
                    onChange={updateField("email")}
                    permissionName="emailPermissions"
                  />
                  <RoleDropDownInput
                    permissionName="roleIdPermissions"
                    style={dropDownStyle}
                    label={"Role"}
                    value={item.roleID}
                    onChange={updateField("roleID", true)}
                  />

                  <DropDownInput
                    style={dropDownStyle}
                    options={employeeTypes}
                    label={"Type du personnel"}
                    value={item.accountType}
                    onChange={updateField("accountType", true)}
                  />
                </SubList>
              </SubSection>
            </ColumnItems>

            <ColumnItems>
              <SubSection>
                <CustomLabel>Contact d'urgence</CustomLabel>
                <SubList>
                  <MaterialInput
                    label={"Nom et prenom du contact d'urgence"}
                    value={item.emergencyContactFullName}
                    onChange={updateField("emergencyContactFullName")}
                  />
                  <MaterialInput
                    label={"Numero de telephone"}
                    value={item.emergencyContactPhoneNumber}
                    onChange={updateField("emergencyContactPhoneNumber")}
                  />
                  <MaterialInput
                    label={"Lieu de residence"}
                    value={item.emergencyContactResidence}
                    onChange={updateField("emergencyContactResidence")}
                  />
                </SubList>
              </SubSection>
            </ColumnItems>

            <ColumnItems>
              <SubSection>
                <CustomLabel>Autre</CustomLabel>
                <SubList>
                  <CustomCheckbox
                    permissionName="isInsuredPermissions"
                    label={"Assuré"}
                    value={item.isInsured}
                    onChange={updateField("isInsured", true)}
                  />
                  <CustomCheckbox
                    label={"Actif"}
                    permissionName="isActivePermissions"
                    value={item.isActive}
                    onChange={updateField("isActive", true)}
                  />
                  <CustomCheckbox
                    permissionName="hasBadgePermissions"
                    label={"Badge"}
                    value={item.hasBadge}
                    onChange={updateField("hasBadge", true)}
                  />

                  {!item.isActive && (
                    <MaterialInput
                      permissionName="departDatePermissions"
                      style={dropDownStyle}
                      type="date"
                      label={"Date de fin"}
                      value={item.departDate}
                      onChange={updateField("departDate")}
                    />
                  )}
                </SubList>
              </SubSection>
            </ColumnItems>
          </RowSection>

          {renderCustomFields()}

          <br />
          <Buttons>
            <CustomButton style={{ padding: "15px 40px" }} onClick={save}>
              {purpose == "UPDATE" ? "Modifier Personnel" : "Ajouter Personnel"}
            </CustomButton>
          </Buttons>
        </Inputs>
      </Container>
    );
  }

  return (
    <PermissionGuard
      permissionName={"profilePermissions"}
      action={purpose == "ADD" ? "CREATE" : "UPDATE"}
    >
      <LoggedInBoilerplate
        showBackButton={true}
        titleLine1={titleLine1}
        titleLine2={titleLine2}
        rightSlot={getHeaderActions()}
      >
        {coreContent}
      </LoggedInBoilerplate>
      {renderCustomFieldModals()}
    </PermissionGuard>
  );

  function getNewRegNumber() {
    serverLine.get("/new-registration-number").then((newNumber) => {
      setItem((newItem) => {
        newItem = { ...item };
        newItem.registrationNumber = newNumber;

        return newItem;
      });
    });
  }

  function updateField(fieldName, dontUseEventValue) {
    return (e) => {
      setItem((newItem) => {
        newItem = { ...item };
        if (dontUseEventValue) {
          newItem[fieldName] = e;
        } else {
          newItem[fieldName] = e.target.value;
        }

        if (fieldName == "contractType") {
          if (newItem[fieldName] == "CDI") {
            newItem.contractEndDate = null;
          }
        }

        return newItem;
      });
    };
  }

  function getItemBeingEditedCard() {
    if (purpose !== "UPDATE") return;
    return (
      <MiniProfileCard item={item} onClick={goTo(`/employee/${itemID}`)} />
    );
  }

  function save() {
    if (purpose == "UPDATE") editItem();
    if (purpose == "ADD") createItem();
  }

  async function loadItemToBeEdited() {
    let data = await serverLine.get(`/employee/?itemID=${itemID}`);

    setItem(data);
    if (data.customFieldDefinitions) setCustomFields(data.customFieldDefinitions);
    if (data.customFieldValues) setCustomFieldValues(data.customFieldValues);
    setLoading(false);
  }

  async function createItem() {
    setLoading(true);

    try {
      let res = await serverLine.post("/employee", {
        nickname: item.nickname,
        accountType: item.accountType,
        profileImage: item.profileImage,
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        dateOfBirth: item.dateOfBirth,
        gender: item.gender,
        roleID: item.roleID,
        employeeResponsibility: item.employeeResponsibility,
        phoneNumber: item.phoneNumber,
        emergencyContactFullName: item.emergencyContactFullName,
        emergencyContactPhoneNumber: item.emergencyContactPhoneNumber,
        emergencyContactResidence: item.emergencyContactResidence,
        hiringDate: item.hiringDate,
        contractEndDate: item.contractEndDate,
        departDate: item.departDate,
        contractType: item.contractType,
        siteID: item.siteID,
        shift: item.shift,
        paymentType: item.paymentType,
        dayOfRest: item.dayOfRest,
        cnpsNumber: item.cnpsNumber,
        baseSalary: item.baseSalary,
        prime: item.prime,
        isInsured: item.isInsured,
        isActive: item.isActive,
        hasBadge: item.hasBadge,
        //
        nationality: item.nationality,
        numberOfChildren: item.numberOfChildren,
        marriageStatus: item.marriageStatus,
        customFieldValues,
        customFieldDefinitions: customFields,
      });

      goTo(`/employees`)();
      // goTo(`/employee/${res._id}`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }

  async function editItem() {
    setLoading(true);

    try {
      let res = await serverLine.patch("/employee", {
        itemID,
        changes: {
          nickname: item.nickname,
          accountType: item.accountType,
          profileImage: item.profileImage,
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          dateOfBirth: item.dateOfBirth,
          gender: item.gender,
          roleID: item.roleID,
          employeeResponsibility: item.employeeResponsibility,
          phoneNumber: item.phoneNumber,
          emergencyContactFullName: item.emergencyContactFullName,
          emergencyContactPhoneNumber: item.emergencyContactPhoneNumber,
          emergencyContactResidence: item.emergencyContactResidence,
          hiringDate: item.hiringDate,
          contractEndDate: item.contractEndDate,
          departDate: item.departDate,
          contractType: item.contractType,
          siteID: item.siteID,
          shift: item.shift,
          paymentType: item.paymentType,
          dayOfRest: item.dayOfRest,
          cnpsNumber: item.cnpsNumber,
          baseSalary: item.baseSalary,
          prime: item.prime,
          isInsured: item.isInsured,
          isActive: item.isActive,
          hasBadge: item.hasBadge,
          //
          nationality: item.nationality,
          numberOfChildren: item.numberOfChildren,
          marriageStatus: item.marriageStatus,
          customFieldValues,
          customFieldDefinitions: customFields,
        },
      });

      goTo(`/employees`)();
      // goTo(`/employee/${res._id}`)();
      window.popupAlert(t("done"));
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
